import React, { FC } from "react";

import { bem } from "@react-md/utils";
// eslint-disable-next-line no-restricted-imports
import AntdSteps, { StepsProps as AntdStepsProps } from "antd/es/steps";
import cn from "classnames";

const block = bem("mmc-steps");

export interface StepsProps extends AntdStepsProps {}

const Steps: FC<StepsProps> = ({ className, ...props }) => {
  return <AntdSteps className={cn(block(), className)} {...props} />;
};

export default Steps;
